import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

const GUMROAD_AFFILIATE_URL = "https://findaura.gumroad.com/affiliates";

export default function Affiliate() {
  return (
    <section
      id="affiliate"
      data-testid="affiliate-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-20"
      style={{ background: "#FAF9F6" }}
    >
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-6"
        >
          <span className="overline" data-testid="affiliate-overline">Creator Program</span>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            Become an <em>affiliate</em>.
          </h2>
          <div className="gold-hair mt-8" />
          <p className="mt-8 max-w-md text-[15px] leading-relaxed text-[#5C5A56]">
            Are you a creator whose audience is chasing the soft life? Apply to earn generous
            commissions sharing Findaura with women who need it. Applications are managed on
            Gumroad and approved personally.
          </p>

          <ul className="mt-10 space-y-4 text-[14px] text-[#1A1A1A]">
            {[
              "40% commission on every sale",
              "Editorial-quality creative assets",
              "First look at new drops",
            ].map((t, i) => (
              <li key={i} className="flex gap-3">
                <span className="font-serif italic text-[#C28C55]">0{i + 1}.</span>
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-6 card-luxe text-center"
          data-testid="affiliate-cta-card"
        >
          <span className="overline block" data-testid="affiliate-cta-overline">Apply · 40% Commission</span>
          <h3 className="font-serif font-light text-3xl md:text-4xl mt-5 leading-tight">
            Join the <em>Findaura</em> creator circle.
          </h3>
          <p className="mt-5 text-[14px] text-[#5C5A56] max-w-sm mx-auto leading-relaxed">
            Applications are hosted securely on Gumroad. Sign in or create an account, then apply
            in a couple of clicks.
          </p>

          <a
            href={GUMROAD_AFFILIATE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary mt-10 inline-flex"
            data-testid="affiliate-apply-button"
          >
            Apply on Gumroad
            <ExternalLink size={14} aria-hidden />
          </a>

          <p className="mt-6 text-xs tracking-widest uppercase text-[#5C5A56]">
            Opens in a new tab · gumroad.com
          </p>
        </motion.div>
      </div>
    </section>
  );
}
